import { render, staticRenderFns } from "./GroundTruthDetail.vue?vue&type=template&id=52e01df5&scoped=true&"
import script from "./GroundTruthDetail.vue?vue&type=script&lang=js&"
export * from "./GroundTruthDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e01df5",
  null
  
)

export default component.exports